import { useEffect } from "react";

export default function useEffectAsync(cb, depends) {
    useEffect(() => {
        const abortController = new AbortController();
        (async () => {
            await cb(abortController);
        })();
        return () => {
            abortController.abort();
        }
    }, depends);
}